import { LoadingCoffeeCup } from "@dea-web/ui";
import styles from "./styles";
import useCss from "../../hooks/useCss";

interface Props {
  overlay?: boolean;
  center?: boolean;
}

const SbuxLoader = ({ overlay = false, center = false }: Props) => {
  const classes = useCss(styles);
  const className = overlay
    ? classes.overlay
    : center
      ? classes.center
      : classes.inline;
  return (
    <div className={className}>
      <LoadingCoffeeCup width={75} height={75} />
    </div>
  );
};

export default SbuxLoader;
